import resume from "../assets/pdf/pw2_115-Siddharth-Bisht-Resume.pdf";
import profileImg from "../assets/png/profileImg.png";

export const headerData = {
  name: "Siddharth Bisht",
  title: "Web Developer",
  desciption:
    "“How many programmers does it take to change a light bulb? None, that’s a hardware problem.”",
  image: profileImg,
  resumePdf: resume,
};

// import resume from "../assets/pdf/resume.pdf";
// import profileImg from "../assets/png/profileImg.png";


